import CallServiceTable from "../../components/Tables/CallServiceTable";
// import { H3, Anchor } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
// import { useModal } from "../../contexts/ModalContext";
// import TableComplete from "../../components/Tables/TableComplete";
// import { Circle } from "../../components/Animation";
// import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
// import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import { useAuth } from "../../contexts/AuthContext";
// import { Request } from "../../hooks/Request";
// import ListDocument from "../../components/common/ListDocument";
import { addFiltersDefault, headerClientList } from "../../utils/constant";
import ListDocumentMosaico from "../../components/common/ListDocumentMosaico";

const ClientList = () => {
  const { user } = useAuth();
  const { openDialog } = useDialog();
  // const { openModal, onClose } = useModal();

  // function listDocumentPdf(procedure) {
  //   openDialog(<RenderPdf procedure={procedure} />);
  // }
  // function generateSettlementProforma(procedure) {
  //   openModal(<RenderLiquidaciónProforma procedure={procedure} />);
  // }
  // function viewProcedure(procedure) {
  //   openModal(
  //     <ProcedureData procedure={procedure} onClose={onClose} user={user} />
  //   );
  // }

  // function handleDocument(procedure) {
  //   openModal(<ListDocument procedure={procedure} deleteDocument={false} />);
  // }

  function handleDocumentMosaico(procedure) {
    openDialog(<ListDocumentMosaico procedure={procedure} urlApi={`tradecruz/${procedure.id}/documentsByClients`} deleteDocument={false} />);
  }
  if (!user?.company[0])
    return ''
  else
    return (
      <div>
        <CallServiceTable
          // onClick={viewProcedure}
          // urlApi={`procedure/byuserid/${user?.user?.id}/companyId/${user?.company[0]?.id}/pag`}
          urlApi={`/procedure/openProcedures`}
          addUrl={`companyId=${user?.company[0]?.id}`}
          addFilters={addFiltersDefault}
          filters={[
            {
              name: "Years",
              default: "",
              label: "Gestión",
              type: "multiSelect",
              defaultValue: { value: '2026', label: '2026' },
              options: [
                {
                  label: "2026",
                  name: "2026",
                  initial: true,
                },
                {
                  label: "2025",
                  name: "2025",
                },
                {
                  label: "2024",
                  name: "2024",
                },
                {
                  label: "2023",
                  name: "2023",
                },
                {
                  label: "2022",
                  name: "2022",
                },
                {
                  label: "2021",
                  name: "2021",
                },
                {
                  label: "2020",
                  name: "2020",
                },
                {
                  label: "2019",
                  name: "2019",
                },
              ],
            },
            {
              name: "dateQuery",
              label: "Filtrar fecha por:",
              // defaultValue: "fechaDeFacturación",
              options: [
                {
                  label: "Fecha de facturación",
                  name: "fechaDeFacturación",
                },
                {
                  label: "Fecha aceptación",
                  name: "a2FechaDeAceptación",
                },
              ],
            },
            { type: "rangeDate" },
          ]}
          header={[
            ...headerClientList,
            {
              name: "Reports",
              type: "action",
              label: "Reportes",
              actions: [
                {
                  label: "Ver documentos",
                  icon: "fa-solid fa-folder",
                  action: handleDocumentMosaico,
                  color: "text-[#1d4ed8]",
                },
              ],
            },
          ]}
          // addUrl={`userId=${localStorage.getItem("id")}`}
          statusPaination={false}
          showTable={true}
          indexSelectedRef='id'
        />
      </div>
    );
};

// const ProcedureData = ({ procedure }) => {
//   const { data, loading } = Request({
//     urlApi: `/clientStats/procedures/${procedure.id}/data`,
//   });
//   if (!loading) {
//     return <Circle />;
//   }
//   function hadleDocument(list) {
//     let listDocument = [];
//     list.forEach((dataSet) => {
//       if ((dataSet.type = "fileStatus")) {
//         listDocument = [...listDocument, ...dataSet.fileStates];
//       } else {
//         listDocument = [
//           ...listDocument,
//           { ...dataSet, url: dataSet.value, name: dataSet.label },
//         ];
//       }
//     });
//     return listDocument;
//   }
//   return (
//     <div>
//       <div className="bg-white mb-2 rounded-md p-2">
//         <h3 className="text-xl font-semibold text-center">Datos</h3>
//         {data.map((item) =>
//           item.type !== "fileStatus" && item.type !== "file" ? (
//             <div key={item.id} className="flex gap-2 mx-1 my-1">
//               <H3>{item.label}:</H3>
//               <H3 className="font-normal">{item.value}</H3>
//             </div>
//           ) : null
//         )}
//       </div>
//       <div className="bg-white rounded-md">
//         <h3 className="text-xl font-semibold text-center mb-2">Documentos</h3>
//         <TableComplete
//           header={[
//             {
//               name: "name",
//               label: "Documento",
//             },
//             {
//               name: "url",
//               label: "Enlace",
//               type: "custom",
//               builder: (item) => {
//                 if (item) {
//                   return (
//                     <Anchor
//                       href={item}
//                       className="text-[#1d4ed8] underline"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       Abrir
//                     </Anchor>
//                   );
//                 } else {
//                   return "-";
//                 }
//               },
//             },
//             {
//               name: "number",
//               label: "Nro",
//             },

//             {
//               label: "Fecha",
//               name: "creationDate",
//               type: "date",
//             },
//             {
//               name: "presentation",
//               label: "Presentación",
//             },
//             {
//               name: "status",
//               label: "Estado",
//             },
//             {
//               label: "Proveedor/Emisor",
//               name: "provider",
//             },
//           ]}
//           data={hadleDocument(data)}
//         />
//       </div>
//     </div>
//   );
// };

export default ClientList;
